import React, { type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";
import SupIndicatorNeutral from "../../../icons/IndicatorNeutral";
import SupIndicatorDown from "../../../icons/IndicatorDown";
import SupIndicatorUp from "../../../icons/IndicatorUp";

interface DirectionalIndicatorProps {
  className?: string;
  direction?: "down" | "up" | "neutral";
  value: number | string;
  suffix?: string | JSX.Element;
}

const ICON = {
  down: <SupIndicatorDown width="1.25rem" height="1.25rem" />,
  up: <SupIndicatorUp width="1.25rem" height="1.25rem" />,
  neutral: <SupIndicatorNeutral width="1.25rem" height="1.25rem" />,
};

const STYLES = {
  down: "text-error-800 bg-error-75",
  up: "text-success-800 bg-success-100",
  neutral: "text-neutral-900 bg-neutral-100",
};

export function SupDirectionalIndicator({ className, direction = "neutral", value, suffix }: DirectionalIndicatorProps) {
  return (
    <span className={twMerge("sup-directional-indicator inline-flex items-center px-1 py-0.5", STYLES[direction], className)}>
      {ICON[direction]}
      <Text as="span" variant="caption" className="inline-block ml-1">
        {value}
        {suffix}
      </Text>
    </span>
  );
}
